var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOurFeature4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_322_53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5161 14.9504C28.496 17.1814 27.8587 19.3632 26.6749 21.2543C25.4911 23.1454 23.8069 24.6719 21.8089 25.6647L15.6589 29.0075L9.50892 25.7932C7.49146 24.7907 5.79439 23.2441 4.60925 21.3282C3.4241 19.4123 2.79806 17.2032 2.80177 14.9504V3.29325C2.80177 2.72493 3.02754 2.17988 3.4294 1.77802C3.83127 1.37616 4.37631 1.15039 4.94463 1.15039H26.3732C26.9415 1.15039 27.4866 1.37616 27.8884 1.77802C28.2903 2.17988 28.5161 2.72493 28.5161 3.29325V14.9504Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4448 17.2214C12.4448 18.0739 12.7834 18.8915 13.3862 19.4943C13.989 20.0971 14.8066 20.4357 15.6591 20.4357C16.0894 20.4677 16.5215 20.4065 16.926 20.2563C17.3305 20.1061 17.6978 19.8704 18.0029 19.5653C18.3081 19.2602 18.5438 18.8929 18.694 18.4884C18.8442 18.0839 18.9054 17.6517 18.8734 17.2214C18.8734 14.0072 12.4448 14.0072 12.4448 10.7929C12.4128 10.3626 12.474 9.93043 12.6242 9.52593C12.7744 9.12143 13.0101 8.7541 13.3152 8.44899C13.6203 8.14389 13.9876 7.90818 14.3921 7.75797C14.7966 7.60776 15.2288 7.54657 15.6591 7.57858C16.5116 7.57858 17.3291 7.91723 17.9319 8.52002C18.5347 9.12282 18.8734 9.94038 18.8734 10.7929",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6592 7.57938V5.43652",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6592 22.5794V20.4365",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_322_53"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.65918 0.0791016)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOurFeature4);
export default __webpack_public_path__ + "static/media/icon-our-feature-4.5d63451d89f3fa8740ba33f72c00dd2e.svg";
export { ForwardRef as ReactComponent };